import React from 'react';

import { AccessInfo, AgeGroup, Piwik, SiteCoreDictionary } from '../../types';

interface FormBlockedInfoProps {
    accessInfo: AccessInfo;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const FormBlockedInfo = ({ accessInfo, dictionary, piwik }: FormBlockedInfoProps) => {
    const { regionInfoUnder18, regionInfoUserIsHighFraudRisk } = dictionary;
    const { userAgeGroup, userIsHighFraudRisk } = accessInfo;

    if (userAgeGroup !== AgeGroup.ADULT) {
        return (
            <div className="block-information">
                <p
                    className="description"
                    data-track-id={piwik?.regionBlockEcommerce?.regionBlockFormBlockedUnder18?.dataTrackId}
                    data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockFormBlockedUnder18?.dataTrackLinkname}
                    id={piwik?.regionBlockEcommerce?.regionBlockFormBlockedUnder18?.dataTrackId}
                >
                    {regionInfoUnder18}
                </p>
            </div>
        );
    }

    if (userIsHighFraudRisk) {
        return (
            <div className="block-information">
                <p
                    className="description"
                    data-track-id={piwik?.regionBlockEcommerce?.regionBlockFormBlockedUserIsHighFraudRisk?.dataTrackId}
                    data-track-linkname={
                        piwik?.regionBlockEcommerce?.regionBlockFormBlockedUserIsHighFraudRisk?.dataTrackLinkname
                    }
                    id={piwik?.regionBlockEcommerce?.regionBlockFormBlockedUserIsHighFraudRisk?.dataTrackId}
                >
                    {regionInfoUserIsHighFraudRisk}
                </p>
            </div>
        );
    }

    return null;
};

export default FormBlockedInfo;
